import * as React from "react";
import { connect } from "react-redux";
import { ErrorBoundary } from "../../../../errors/ErrorBoundary";
import Modal, { ModalSize } from "../../../../misc/components/modal";
import * as Actions from "../../actions";
import { AnalyseState, WaveformType } from "../../interfaces/state";
import { HourSegmentsTable } from "./HourSegmentsTable";
import { IHourSegmentsModalProps } from "./interfaces";
import { PeaksPoint } from "../../interfacesPeaks/PeaksJS";

export const HourSegmentsModal = (props: IHourSegmentsModalProps) => {
    const closeModal = () => props.dispatch(Actions.CloseHourSegmentsModalAction.create());

    return (
        <Modal
            show={props.isVisible}
            size={ModalSize.Large}
            header="Hour Segments List"
            closeModalHandler={closeModal}
        >
            <div className="modal-body">
                <ErrorBoundary>
                    <HourSegmentsTable
                        dispatch={props.dispatch}
                        hourSegments={props.hourSegments}
                        coughEventTimestamps={props.coughEventTimestamps}
                        selectedWaveformType={props.selectedWaveformType}
                        selectedSegment={props.selectedSegment}
                    />
                </ErrorBoundary>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={closeModal}>
                    Close
                </button>
            </div>
        </Modal>
    );
}

const mapStateToProps = (state: AnalyseState) => {

    const coughEventTimestamps =
        ((state.core.peaksJs && state.core.peaksJs.points
            ? state.core.peaksJs.points.getPoints()
            : []) as PeaksPoint[])
        .filter(pp => pp.eventTypeName === "Cough Peak")
            .map(pp => pp.timestamp + (pp.multiDayOffset || 0));

    return {
        isVisible: state.core.isHourSegmentsModalOpened,
        hourSegments: state.core.hourSegmentsMap.get(state.core.selectedWaveform),
        coughEventTimestamps,
        selectedWaveformType: WaveformType[state.core.selectedWaveform],
        selectedSegment: state.core.selectedSegment
    };
};

export default connect<IHourSegmentsModalProps, any, void>(mapStateToProps)(HourSegmentsModal);
